import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@wix/design-system';
import s from './Content.scss';

export const Default = () => {
  const { t } = useTranslation();
  return (
    <Text className={s.withDash} weight='bold' light>
      {t('premium-purchase-plan.header.strip.money_back')}
    </Text>
  );
};
